import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useTranslate, authenticationState, customerState } from '@repo/unicity'
import { useAtomValue } from 'jotai'
import { useEffect, useState } from 'react'
import Phone from './assets/phone.svg?react'
import Mail from './assets/email.svg?react'
import Facebook from './assets/facebook.svg?react'
import { paymentApis } from '../creditcard/Apis'
import IconTitle from './assets/IconTitle.svg?react'
import Cover from './assets/Cover.png'
import { paymentResponseApis } from './Apis'
import InputBox from '../forms/inputbox/InputBox'
import { spotlightCustomerHelpers as customerHelpers } from '../../helpers/customerCompat'
import copy from 'copy-to-clipboard'

const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window
    return {
        width,
        height
    }
}

const useSizeWindow = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowDimensions
}

const Success = () => {
    const { translate } = useTranslate()
    const qs = new URLSearchParams(window.location.search)
    const customer = useAtomValue(customerState)
    const auth = useAtomValue(authenticationState)
    const { width } = useSizeWindow()
    const [loading, setLoading] = useState(false)
    const [states, setStates] = useState({
        paymentId: '',
        email: '',
        orderSummary: '',
        orderNumber: ''
    })

    const [referralCode, setReferralCode] = useState('')
    const [isCopied, setIsCopied] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)

    const phone = '050-5527-0735'
    const email = 'Japan.MemberService@unicity.com'

    const copyToClipboard = () => {
        if (!customer.id.unicity && referralCode.length === 0) return
        if (!loading) {
            copy(`https://ufeelgreat.com/c/${referralCode}`)

            setIsCopied(true)
            setTimeout(() => {
                setIsCopied(false)
            }, 5000)
        }
    }

    const getReferralCode = async () => {
        try {
            const response = await paymentResponseApis.getReferralCode({ token: auth.token as string })
            setReferralCode(response.data.items[0].referralCode)
        } catch (e) {
            console.error(e)
        }
    }

    const getHydra3DSPaymentDetail = async () => {
        try {
            setLoading(true)
            const paymentId = qs.get('paymentId')
            const baId = customer.id.unicity
            const response = await paymentApis.getPaymentDetail({ paymentId: paymentId as string, baId, type: 'shop' })
            setStates({
                ...states,
                paymentId: paymentId as string,
                email: response.data.email,
                orderSummary: `${response.data.total_price.value} ${response.data.total_price.suffix}`,
                orderNumber: response.data.order_number
            })

            // await paymentApis.updateLogByOrder({
            //     paymentId: paymentId as string,
            //     orderNumber: response.data.order_number
            // })

            setLoading(false)
        } catch (e) {
            console.error(e)
            setLoading(false)
            setIsLoaded(true)
        }
    }

    useEffect(() => {
        if (qs.get('paymentId') && states.orderNumber.length === 0 && !loading && !isLoaded) {
            getHydra3DSPaymentDetail()
            getReferralCode()
        }
    }, [qs.get('paymentId'), states.orderNumber, loading])

    const CardThankYou = () => (
        <Card
            sx={{
                '&.MuiPaper-root': {
                    boxSizing: 'border-box',
                    '@media (max-width: 390px)': {
                        width: '343px',
                        maxWidth: '343px'
                    },
                    '@media (min-width: 391px)': {
                        width: '350px',
                        maxWidth: '350px',
                        padding: '24px'
                    },
                    '@media (min-width: 430px)': {
                        width: '375px',
                        maxWidth: '375px',
                        padding: '24px'
                    },
                    '@media (min-width: 768px)': {
                        width: '500px',
                        maxWidth: '500px',
                        padding: '24px'
                    },
                    '@media (min-width: 820px)': {
                        width: '600px',
                        maxWidth: '600px',
                        padding: '24px'
                    },
                    '@media (min-width: 1024px)': {
                        width: '772px',
                        maxWidth: '772px',
                        height: 'fit-content'
                    },
                    '@media (min-width: 1180px)': {
                        width: '672px',
                        maxWidth: '672px',
                        height: 'fit-content'
                    },
                    '@media (min-width: 1366px)': {
                        width: '772px',
                        maxWidth: '772px',
                        height: 'fit-content'
                    }
                }
            }}>
            <CardContent
                sx={{
                    gap: '24px',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                <Stack gap={'24px'}>
                    <IconTitle />
                    <Typography variant="cardTitle" color="#003B6F">
                        {translate('thank_you_for_your_purchase')}
                    </Typography>
                    <Typography
                        variant="cardSubtitle"
                        color="#003B6F"
                        fontSize={{
                            xs: '16px'
                        }}>
                        {translate('thank_you_for_your_order_caption')}
                    </Typography>
                </Stack>
                <Stack gap={'12px'}>
                    <Stack direction={'row'}>
                        <Typography variant="cardSubtitle" color="#003B6F" fontSize={'16px'}>
                            {translate('order_number')}:
                        </Typography>
                        &nbsp;
                        <Typography variant="cardSubtitle" color="rgba(138, 155, 176, 1)" fontSize={'16px'}>
                            {states.orderNumber.replace('81-', '')}
                        </Typography>
                    </Stack>
                    <Stack direction={'row'}>
                        <Typography variant="cardSubtitle" color="#003B6F" fontSize={'16px'}>
                            {translate('unicity_id')}
                        </Typography>
                        &nbsp;
                        <Typography variant="cardSubtitle" color="rgba(138, 155, 176, 1)" fontSize={'16px'}>
                            {customer?.id.unicity}
                        </Typography>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )

    const CardGuide = () => (
        <Card
            sx={{
                '&.MuiPaper-root': {
                    boxSizing: 'border-box',
                    '@media (max-width: 390px)': {
                        width: '343px',
                        maxWidth: '343px'
                    },
                    '@media (min-width: 391px)': {
                        width: '350px',
                        maxWidth: '350px',
                        padding: '24px'
                    },
                    '@media (min-width: 430px)': {
                        width: '375px',
                        maxWidth: '375px',
                        padding: '24px'
                    },
                    '@media (min-width: 768px)': {
                        width: '500px',
                        maxWidth: '500px',
                        padding: '24px'
                    },
                    '@media (min-width: 820px)': {
                        width: '600px',
                        maxWidth: '600px',
                        padding: '24px'
                    },
                    '@media (min-width: 1024px)': {
                        width: '772px',
                        maxWidth: '772px',
                        height: 'fit-content'
                    },
                    '@media (min-width: 1180px)': {
                        width: '672px',
                        maxWidth: '672px',
                        height: 'fit-content'
                    },
                    '@media (min-width: 1366px)': {
                        width: '772px',
                        maxWidth: '772px',
                        height: 'fit-content'
                    }
                }
            }}>
            <CardContent>
                <Stack
                    gap={{
                        xs: '24px',
                        sm: '60px'
                    }}
                    sx={{
                        '@media (min-width: 1024px)': {
                            flexDirection: 'row'
                        }
                    }}>
                    <Stack>
                        <img src={Cover} alt="cover" />
                    </Stack>
                    <Stack gap={'20px'}>
                        <Stack gap={'8px'}>
                            <Typography variant="cardTitle" color="#003B6F">
                                {translate('feelgreat_guide')}
                            </Typography>
                            <Typography variant="cardSubtitle" color="#003B6F" fontSize={'14px'}>
                                {translate('feelgreat_guide_description')}
                            </Typography>
                        </Stack>
                        <Stack>
                            <Button
                                disableElevation
                                variant="contained"
                                color="primary"
                                sx={{ minWidth: '170px', width: '170px' }}
                                onClick={() => window.open('https://fg.unicity.com/japan', '_blank')}>
                                {translate('check_it_out')}
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )

    const CardContact = () => (
        <Card
            sx={{
                '&.MuiPaper-root': {
                    boxSizing: 'border-box',
                    '@media (max-width: 375px)': {
                        width: '343px',
                        maxWidth: '343px'
                    },
                    '@media (min-width: 391px)': {
                        width: '350px',
                        maxWidth: '350px',
                        padding: '24px'
                    },
                    '@media (min-width: 430px)': {
                        width: '375px',
                        maxWidth: '375px',
                        padding: '24px'
                    },
                    '@media (min-width: 768px)': {
                        width: '500px',
                        maxWidth: '500px',
                        height: 'fit-content'
                    },
                    '@media (min-width: 820px) and (orientation: portrait)': {
                        width: '600px',
                        maxWidth: '600px',
                        padding: '24px'
                    },
                    '@media (min-width: 1024px)': {
                        width: '772px',
                        maxWidth: '772px',
                        height: 'fit-content',
                        padding: '24px'
                    },
                    '@media (min-width: 1180px) and (orientation: landscape)': {
                        width: '396px',
                        maxWidth: '396px',
                        height: 'fit-content'
                    }
                }
            }}>
            <CardContent style={{ padding: width < 600 ? '30px 20px' : 30, display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <Stack gap={'12px'}>
                    <Typography variant="body2" color="#003B6F" fontSize={'16px'}>
                        {translate('you_have_questions')}
                    </Typography>
                    <Typography variant="cardTitle" color="#003B6F">
                        {translate('please_contact_us')}
                    </Typography>
                </Stack>

                <Stack>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                sm: 'column',
                                md: 'column'
                            },
                            width: '100%',
                            flex: '1',
                            gap: '16px'
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '100%'
                                }
                            }}>
                            <Phone />
                            <Typography
                                variant="caption"
                                sx={{
                                    color: '#003764',
                                    cursor: 'pointer',
                                    fontSize: {
                                        xs: '14px',
                                        sm: '16px'
                                    }
                                }}
                                onClick={() => window.open(`tel:${phone}`, '_self')}>
                                {phone}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '100%'
                                }
                            }}>
                            <Mail />
                            <Typography
                                variant="caption"
                                sx={{
                                    color: '#003764',
                                    cursor: 'pointer',
                                    fontSize: {
                                        xs: '14px',
                                        sm: '16px'
                                    }
                                }}
                                fontSize={{
                                    xs: '14px',
                                    sm: '16px'
                                }}
                                onClick={() => window.open(`mailto:${email}`, '_self')}>
                                {email}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '100%'
                                }
                            }}>
                            <Facebook />
                            <Typography
                                variant="caption"
                                sx={{
                                    color: '#003764',
                                    cursor: 'pointer',
                                    fontSize: {
                                        xs: '14px',
                                        sm: '16px'
                                    }
                                }}
                                onClick={() => window.open(`https://www.facebook.com/UnicityJapan/`, '_blank')}>
                                facebook.com/UnicityJapan
                            </Typography>
                        </Box>
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    )

    const CardReferral = () => (
        <Card
            sx={{
                '&.MuiPaper-root': {
                    boxSizing: 'border-box',
                    '@media (max-width: 375px)': {
                        width: '343px',
                        maxWidth: '343px'
                    },
                    '@media (min-width: 391px)': {
                        width: '350px',
                        maxWidth: '350px',
                        padding: '24px'
                    },
                    '@media (min-width: 430px)': {
                        width: '375px',
                        maxWidth: '375px',
                        padding: '24px'
                    },
                    '@media (min-width: 768px)': {
                        width: '500px',
                        maxWidth: '500px',
                        height: 'fit-content'
                    },
                    '@media (min-width: 820px) and (orientation: portrait)': {
                        width: '600px',
                        maxWidth: '600px',
                        padding: '24px'
                    },
                    '@media (min-width: 1024px)': {
                        width: '772px',
                        maxWidth: '772px',
                        height: 'fit-content',
                        padding: '24px'
                    },
                    '@media (min-width: 1180px) and (orientation: landscape)': {
                        width: '396px',
                        maxWidth: '396px',
                        height: 'fit-content'
                    }
                }
            }}>
            <CardContent>
                <Stack gap={'18px'}>
                    <Typography variant="cardTitle" color="#003B6F">
                        {translate('fg_refer_friend')}
                    </Typography>
                    <InputBox label={translate('your_referral_link')} value={`https://ufeelgreat.com/c/${referralCode}`} />

                    {/* TODO: copy link */}
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '127px', width: '165px', color: isCopied ? '#6FCF97' : 'white' }}
                        disableElevation
                        onClick={copyToClipboard}>
                        {isCopied ? translate('copied') : translate('copy_link')}
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    )

    return (
        <Stack alignItems={'center'}>
            {customerHelpers.customerStatus(customer) === 'H' ? (
                <StackStyledHDesktop>
                    <CardThankYou />
                    <CardContact />
                </StackStyledHDesktop>
            ) : (
                <StackStyledDesktop gap={'24px'}>
                    <Stack direction={'column'} gap={'12px'}>
                        <CardThankYou />
                        <CardGuide />
                    </Stack>
                    <Stack direction={'column'} gap={'12px'}>
                        <CardContact />
                        <CardReferral />
                    </Stack>
                </StackStyledDesktop>
            )}
        </Stack>
    )
}

const StackStyledDesktop = styled(Stack)`
    padding-top: 30px;
    padding-bottom: 30px;
    min-height: 50vh;
    gap: 12px;
    @media screen and (min-width: 820px) {
        display: flex;
        flex-direction: column;
    }
    @media screen and (min-width: 1180px) {
        display: grid;
        grid-template-columns: 672px 396px;
        gap: 24px;
    }
    @media screen and (min-width: 1200px) {
        display: grid;
        grid-template-columns: 772px 396px;
        gap: 24px;
    }
`

const StackStyledHDesktop = styled(Stack)`
    padding-top: 30px;
    min-height: 50vh;
    margin-bottom: 30px;
    flex-direction: column;
    gap: 12px;
    @media screen and (min-width: 1200px) {
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
    }
`

export default Success
